// Filtercomponent.js
import React, { useState, useEffect } from 'react';
import SearchFilter from './features/SearchFilter';
import ProductList from './features/ProductList';
import axiosInstance from '../../utils/axiosInstance';
import Navbar from '../nav';
import ProductSkeleton from '../../utils/ProductSkeleton';

const FilterComponent = () => {
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNav, setShowNav] = useState(true);

  const handleScroll = () => {
    const scrollPosition = window.scrollY;

    // Set showNav based on the scroll position
    setShowNav(scrollPosition <= 0);
  };

  useEffect(() => {
    // Add scroll event listener when component mounts
    window.addEventListener('scroll', handleScroll);

    // Remove scroll event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); 

  
  const handleSearch = async ({ searchTerm, category, sortBy }) => {
    try {
      setLoading(true);

      const response = await axiosInstance.get('/api/products/search/details', {
        params: {
          name: searchTerm || '',
          category: category || '',
          sortBy: sortBy || '',
        },
      });

      setFilteredProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      // Handle error (e.g., show an error message to the user)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial load, you may want to load all products here
    handleSearch({ searchTerm: '', category: 'All', sortBy: 'None' });
  }, []);

  return (

    <>
          {showNav && (
        // Your nav bar component goes here
        <Navbar />

      )}

    <div className="container md:mx-auto p-4 mt-1  md:w-full">
      <SearchFilter onSearch={handleSearch} />
      <hr />
      {loading ? (
        <p> <ProductSkeleton /></p>
      ) : (
        <ProductList products={filteredProducts} />
      )}
    </div>
    </>
  );
};

export default FilterComponent;
